import * as React from 'react';
import type { SVGProps } from 'react';

const SvgTeams = (props: SVGProps<SVGSVGElement>) => {
  const id = React.useId().replace(/:/g, '');
  const clipA = `Teams_svg__a-${id}`;
  const clipB = `Teams_svg__b-${id}`;
  const gradient = `Teams_svg__c-${id}`;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={52}
      height={20}
      fill='none'
      {...props}
    >
      <g clipPath={`url(#${clipA})`}>
        <rect width={52} height={20} fill='#6B727F' rx={10} />
        <g clipPath={`url(#${clipB})`}>
          <path
            fill={`url(#${gradient})`}
            d='M17.187 7.698q-.778-.509-1.804-.509a3.1 3.1 0 0 0-1.76.528 3.7 3.7 0 0 0-1.252 1.428 4.3 4.3 0 0 0-.458 1.969c0 .712.165 1.354.495 1.95q.495.891 1.34 1.415.846.522 1.848.522a4 4 0 0 0 2.593-.931.24.24 0 0 0 .094-.164.3.3 0 0 0-.056-.189l-.3-.428q-.14-.214-.351-.038a3.3 3.3 0 0 1-.89.528 2.8 2.8 0 0 1-1.052.189q-.652-.001-1.228-.296a2.54 2.54 0 0 1-.953-.85 2.85 2.85 0 0 1-.463-1.282h5.562q.237 0 .263-.176V11.1q0-1.107-.425-2a3.4 3.4 0 0 0-1.203-1.403zm-4.197 2.837q.1-.692.451-1.214a2.54 2.54 0 0 1 .864-.812q.514-.29 1.103-.29.627 0 1.122.283.494.283.8.805.308.521.396 1.227H12.99M25.054 7.56q-.676-.372-1.566-.372-.727 0-1.484.227-.758.226-1.384.705-.1.076-.113.163-.012.089.063.19l.264.363q.137.201.35.05.564-.39 1.071-.553t1.259-.163q.89 0 1.397.585t.507 1.515v.15H23.1q-1.44 0-2.248.592-.81.59-.809 1.673 0 .754.357 1.277t.915.78 1.16.257q1.076 0 1.84-.428.765-.427 1.103-1.007l.025 1.02q0 .25.25.251h.54q.124 0 .187-.063.063-.062.063-.188v-4.315q0-.956-.376-1.648a2.6 2.6 0 0 0-1.052-1.063zm.363 4.22q0 .615-.351 1.132-.35.515-.952.817-.603.303-1.316.302-.763 0-1.252-.346-.49-.345-.489-1.1 0-.692.558-.994t1.547-.302h2.255zM8.782 5.88q0 .126-.063.19-.063.062-.188.062H6.049q-.25 0-.25-.252v-.628q0-.252.25-.252h2.482q.25 0 .25.252zm4.11.252a2.99 2.99 0 0 0-2.983 2.995v5.458a.25.25 0 0 1-.25.251h-.627a.25.25 0 0 1-.25-.251V8.993A3.985 3.985 0 0 1 12.758 5h13.473c.138 0 .25.113.25.252v.628a.25.25 0 0 1-.25.252zm15.594 8.453v-7.02q0-.25.25-.25h.489q.25 0 .25.25l.013.592q.402-.478.997-.73a2.9 2.9 0 0 1 1.146-.252q.84 0 1.471.372.633.371.972 1.05a2.38 2.38 0 0 1 1.052-1.056q.7-.366 1.378-.365.84 0 1.472.372.633.371.977 1.056.344.686.344 1.616v4.365q0 .25-.25.251h-.564q-.125 0-.188-.063-.062-.062-.062-.188V10.32q0-.97-.507-1.54-.508-.572-1.36-.572-.501 0-.945.289a2.2 2.2 0 0 0-.72.774 2.06 2.06 0 0 0-.276 1.037v4.277q0 .25-.25.251h-.564q-.126 0-.188-.063-.063-.062-.063-.188v-4.264q0-.97-.507-1.54-.507-.572-1.36-.572a1.74 1.74 0 0 0-.952.289q-.45.29-.72.78t-.27 1.044v4.264q0 .126-.063.188-.062.063-.187.063h-.564q-.25 0-.25-.251zm13.486.144a4.1 4.1 0 0 1-1.259-.748q-.175-.151-.038-.353l.327-.415q.15-.19.35-.038.465.34 1.003.566t1.09.227q.438 0 .789-.145a1.2 1.2 0 0 0 .545-.415q.194-.272.194-.635a.87.87 0 0 0-.207-.598 1.5 1.5 0 0 0-.583-.384 9 9 0 0 0-1.04-.327q-1.053-.277-1.685-.818t-.632-1.421q0-.54.275-1t.852-.75 1.428-.289q.589 0 1.19.208t1.027.585q.175.15.013.352l-.338.416q-.15.163-.351.025a3 3 0 0 0-.746-.403q-.407-.15-.833-.15-.751 0-1.122.289a.9.9 0 0 0-.37.742c0 .301.132.532.395.717q.395.276 1.41.553.702.188 1.215.459.513.27.82.71.308.44.308 1.07c0 .42-.105.774-.314 1.113q-.312.51-.89.818-.576.308-1.328.308-.789 0-1.497-.27z'
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipA}>
          <rect width={52} height={20} fill='#fff' rx={10} />
        </clipPath>
        <clipPath id={clipB}>
          <path fill='#fff' d='M6 5h40v10H6z' />
        </clipPath>
        <linearGradient
          id={gradient}
          x1={13.403}
          x2={37.843}
          y1={-2.509}
          y2={21.831}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#fff' />
          <stop offset={1} stopColor='#6C7380' />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SvgTeams;
